import { createApp }		from 'vue';

import App					from './App.vue';
import router				from "./router";

import '@fortawesome/fontawesome-free/css/all.css'
import 'vuetify/styles'

import { createVuetify }	from 'vuetify'
import { aliases, fa } 		from 'vuetify/iconsets/fa'
import * as components 		from 'vuetify/components'
import * as directives 		from 'vuetify/directives'
import { VNumberInput } from 'vuetify/labs/VNumberInput'
import { VDateInput } from 'vuetify/labs/VDateInput'

import "./assets/sass/app.scss";

const vuetify = createVuetify({
    components: {
        ...components,
        VNumberInput,
        VDateInput
    },
    directives,
    aliases,
    icons: {
        defaultSet: 'fa',
        sets: {
            fa
        }
    }
})

createApp(App).use(router).use(vuetify).mount('#app');